
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"17","height":"28","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"stroke":"#F7941E","stroke-width":"2","fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M1 18l7.571 8L16 18.15"}}),_c('path',{attrs:{"d":"M8.5 1.5v23.022","stroke-linecap":"square"}})])])
      }
    
      }
    